module.exports = __webpack_public_path__ + "img/jarom-vogel-natures-dance.f31f7d2.jpg";